require("@/assets/scss/index.scss");

import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import i18n from "./i18n";
import "./idle-vue";
import lodash from "lodash";
import moment from "moment";
import Vuelidate from "vuelidate";
import VuelidateErrorExtractor from "vuelidate-error-extractor";
import customForm from "./components/basic/VuelidateForm";
import config from "./assets/js/config";
import page from "./assets/js/page";
import common from "./assets/js/common";
import filter from "./assets/js/filter";
import "./permission";
import bridge from "./assets/js/bridge";
import lang from "./assets/js/lang";
import VCalendar from "v-calendar";
import VueLogger from "vuejs-logger";
import VueScrollactive from "vue-scrollactive";
//import cors from "cors";
//import qrStyling from "./assets/js/qr-code-styling.min.js"
// const isProduction = process.env.VUE_APP_MODE === "PRODUCTION";

// const eventsHub = new Vue();

//기본 컴포넌트 전역등록
const requireComponent = require.context("./components", true, /[\w-]+\.vue$/);
const folder = ["basic", "modal"];
requireComponent.keys().forEach(fileName => {
  if (folder.includes(fileName.split("/").slice(1, 2)[0])) {
    const componentConfig = requireComponent(fileName);
    const componentName = fileName
      .split("/")
      .pop()
      .replace(/\.\w+$/, "");
    Vue.component(componentName, componentConfig.default || componentConfig);
  }
});

//공통js
Vue.use(config);
Vue.use(page);
Vue.use(common);
Vue.use(filter);
Vue.prototype._ = lodash;
Vue.use(bridge);
Vue.use(lang);
Vue.use(VueScrollactive);
//Vue.use(cors);
//Vue.use(qrStyling);
// Vue.use(validator);
// Vue.use(common);
// Vue.use(convert);
// Vue.use(popupManager);
// Vue.use(config);
// Vue.use(i18nUtils);

// Vue.use(Vue2TouchEvents, { swifeTolerance: 10 });
// Vue.use(IScrollView, IScroll);
Vue.prototype.$EventBus = new Vue();
//validate
Vue.use(Vuelidate);
Vue.use(VuelidateErrorExtractor, {
  i18n: "validations",
  template: customForm,
});

Vue.prototype.moment = moment;
Vue.prototype._ = lodash;

Vue.use(VCalendar, {
  componentPrefix: "v",
});

// Vue.use(VueFab, { iconType: "MaterialDesign" });
// Logger
Vue.use(VueLogger, {
  isEnable: true,
  logLevel: "production|staging".includes(process.env.NODE_ENV) ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
});

// Idle Vue
// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   store,
//   idleTime: 60 * 9 * 1000,
//   startAtIdle: false,
// });

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount("#app");
